import * as React from 'react'
import { useState } from 'react'

import { formatPnlColor, formatPnlColorBg } from '@/lib/utils/format'
import { Box, HStack } from '@chakra-ui/react'
import { ThemedText } from '@/components/ui/ThemedText'
import { ChevronDownIcon } from 'lucide-react'

interface PriceDisplayProps {
  price: string
  changePercent: string
  isPositive?: boolean
  isExpanded?: boolean
  onPress?: () => void
  hideExpandIcon?: boolean
}

// 分离价格的整数和小数部分
function formatPrice(priceStr: string) {
  const match = priceStr.match(/^\$([\d,]+)(\.\d+)?$/)
  // console.log('formatPrice', priceStr, match)
  if (match) {
    const integerPart = Intl.NumberFormat('en-US', {
      style: 'decimal',
    }).format(Number(match[1].replaceAll(',', '')))
    const decimalPart = match[2] || ''
    return { integerPart, decimalPart }
  }
  return { integerPart: priceStr, decimalPart: '' }
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  price = '- -',
  changePercent = '- -',
  isPositive = true,
  isExpanded: externalIsExpanded,
  onPress,
  hideExpandIcon = false,
}) => {
  const [internalIsExpanded, setInternalIsExpanded] = useState(false)
  const isExpanded = externalIsExpanded !== undefined ? externalIsExpanded : internalIsExpanded

  // const statusColor =

  const handlePress = () => {
    if (externalIsExpanded === undefined) {
      setInternalIsExpanded(!internalIsExpanded)
    }
    onPress?.()
  }


  const { integerPart, decimalPart } = formatPrice(price)

  return (
    <HStack align="center" justify="space-between">
      <HStack align="center" gap={3}>
        <HStack align="center" gap={2}>
          <Box h={2} w={2} rounded="full" bg={formatPnlColorBg(false, isPositive)} />
          <HStack align="center" gap={0}>
            <ThemedText fontSize="xl" color="text.t1/90" fontWeight="bold">{integerPart}</ThemedText>
            {decimalPart && (
              <ThemedText fontSize="xl" color="text.t1/60" fontWeight="bold">{decimalPart}</ThemedText>
            )}
          </HStack>
        </HStack>
        <HStack h={8} align="center" justify="flex-end" py={1}>
          <ThemedText fontWeight="bold" color={formatPnlColor(false, isPositive)}>
            {changePercent}
          </ThemedText>
        </HStack>
      </HStack>

      {!hideExpandIcon && (
        <Box
          // className='ml-[30px]'
          onClick={handlePress}
        >
          <HStack gap={1} align="center">
            <ChevronDownIcon />
          </HStack>
        </Box>
      )}
    </HStack>
  )
}

export default PriceDisplay
